export class Todo {
  id: string;
  title: string;
  notes: string;
  startDate: string;
  dueDate: boolean;
  completed: boolean;
  starred: boolean;
  important: boolean;
  deleted: boolean;
  status: boolean;
  message: string;
  shortcut: string;
  room: any;
  tags: [
    {
      id: number;
      name: string;
      label: string;
      color: string;
    },
  ];

  /**
   * Constructor
   *
   * @param todo
   */
  constructor(todo) {
    {
      this.id = todo.id;
      this.title = todo.title;
      this.notes = todo.notes;
      this.startDate = todo.startDate;
      this.dueDate = todo.dueDate;
      this.completed = todo.completed;
      this.starred = todo.starred;
      this.important = todo.important;
      this.deleted = todo.deleted;
      this.tags = todo.tags || [];
      this.status = todo.status;
      this.message = todo.message;
      this.shortcut = todo.shortcut;
      this.room = todo.room;
    }
  }

  /**
   * Toggle star
   */
  toggleStar(): void {
    this.starred = !this.starred;
  }

  /**
   * Toggle important
   */
  toggleImportant(): void {
    this.important = !this.important;
  }

  /**
   * Toggle completed
   */
  toggleCompleted(): void {
    this.completed = !this.completed;
  }

  /**
   * Toggle deleted
   */
  toggleDeleted(): void {
    this.deleted = !this.deleted;
  }
}
